import React from "react";
import { X } from "react-feather";
import styled from "styled-components";

const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Input = styled.input.attrs(props => ({
  type: "text",
  size: props.small ? 5 : undefined
}))`
  height: 32px;
  width: 200px;
  border-radius: 5px 0 0 5px;
  padding: 0 16px;
  outline: none;
`;

const ClearButton = styled.button`
  height: 32px;
  width: 34px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  transition: opacity 0.2s, color 0.2s;

  &:hover {
    // opacity: 0.7;
  }
`;

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <FilterWrapper className="filter-wrapper">
    <Input
      id="search"
      className="filter-search-input"
      type="text"
      placeholder="Type to Search..."
      value={filterText}
      onChange={onFilter}
    />
    <ClearButton className="filter-clear-btn" onClick={onClear}><X size={16}/></ClearButton>
  </FilterWrapper>
);

export default FilterComponent;
